import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { useSettings } from '../../hooks/useSettings';

const TopBar: React.FC = () => {
  const { settings } = useSettings();

  return (
    <div className="bg-gray-900 text-white py-1 md:py-2">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center text-xs md:text-sm">
          <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-1 md:mb-0">
            {settings?.phone && (
              <a href={`tel:${settings.phone}`} className="flex items-center hover:text-primary-200">
                <FaPhone className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 flex-shrink-0" />
                <span className="truncate">{settings.phone}</span>
              </a>
            )}
            {settings?.email && (
              <a href={`mailto:${settings.email}`} className="flex items-center hover:text-primary-200">
                <FaEnvelope className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 flex-shrink-0" />
                <span className="truncate">{settings.email}</span>
              </a>
            )}
          </div>
          {settings?.address && (
            <div className="flex items-center text-gray-400 text-xs md:text-sm mt-1 md:mt-0">
              <FaMapMarkerAlt className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 flex-shrink-0" />
              <span className="truncate max-w-[250px] md:max-w-none">{settings.address}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
